<template>
  <v-form ref="form" v-model="validForm">
    <v-autocomplete
      v-model="servicio"
      @change="change"
      :items="servicios"
      item-text="descripcion"
      item-value="id"
      dense
      filled
      :label="label"
      :return-object="returnObject"
      clearable
    ></v-autocomplete>
   
  </v-form>
</template>
<script>
import axios from "axios";

export default {
  props: {
    id: {type: Number, default: null},
    returnObject: {type: Boolean, default: false },
    label: {type: String, default:"Servicio" }
  },
  data() {
    return {
      servicios: [],
      servicio: null,
      validForm: false,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 10) || "Maximo 10 caracteres",
      },
    };
  },
  mounted() {

    // this.servicio = this.id
    
    axios
      .get("/generaciones/serviciosFactura")
      .then((response) => {
        console.log(response);
        this.servicios = response.data;
        if (this.id) {
          this.servicio = response.data.find( r => r.idServicio === this.id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    change() {
      this.$emit('setServicio', this.servicio)
    }
  }
};
</script>